import { useEffect } from 'react';
import { Sparkles } from 'lucide-react';
import './Castle.css';

/**
 * Slide-up congratulatory snippet shown when a reader is promoted to a new
 * castle. Auto-dismisses after a few seconds.
 */
const CastleCelebration = ({ levelName, color, onClose, message }) => {
  useEffect(() => {
    const t = setTimeout(() => onClose && onClose(), 6800);
    return () => clearTimeout(t);
  }, [onClose]);

  return (
    <div
      className="castle-celebration"
      style={{ ['--celebration-color']: color || '#C19A6B' }}
      data-testid="castle-celebration"
    >
      <Sparkles className="w-8 h-8 shrink-0" style={{ color: color || '#C19A6B' }} />
      <div className="flex-1 min-w-0">
        <p className="castle-celebration-title" data-testid="celebration-title">
          مباركٌ ترقّيك إلى قلعة {levelName}!
        </p>
        <p className="castle-celebration-text">
          {message || 'بناؤك الجديد قد بدأ — واصل لتُتمّه ولتنطلق إلى قلعة أعلى.'}
        </p>
      </div>
      <button
        onClick={onClose}
        className="text-muted-foreground hover:text-accent text-xl leading-none px-1"
        aria-label="إغلاق"
        data-testid="celebration-close"
      >×</button>
    </div>
  );
};

export default CastleCelebration;
